/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum AuthType {
    PASSWORD = 'Password',
    REFRESH_TOKEN = 'RefreshToken',
}